/**
 * Created by galweissman on 16/05/2016.
 */
import app from 'app';
import Analytics from 'c/WtAnalytics';
import 'v/InfogfxModal/InfogfxWebpageView';
import 'v/behaviors/GenericVideoPlayer';
import Marionette from 'backbone.marionette';

app.namespace.View.InfogfxModalView = Marionette.ItemView.extend({
  eventNamespace: 'infogfxModal',
  className: 'wt-infogfx-modal',
  id: 'infogfxModal',

  INFOGFX_TEMPLATES: [
    {
      ID: 'WEBPAGE',
      ASSET_TYPE: 'webpagemetaasset',
      PREVIEW_TYPE: 'IMAGE',
      TITLE: 'Create a Webpage',
      THUMBNAIL: '/resources/img/infogfx_webpage_asset.jpeg',
      CAPTION: 'Webpage',
      DEMO: '//dp4stoslb9jdl.cloudfront.net/Resources/studio/video/uploadInfographicsWebpageDemo.mp4',
      ICON: '',
      VIEW: 'InfogfxWebpageView',
    },
  ],

  ui: {
    video: 'video',
    videoContainer: '.js-mini-video-container',
    xButton: '.js-close-modal',
    saveButton: '.js-action-save',
    previewButton: '.js-action-preview',
    innerView: '.js-infogfx-inner-view',
    loading: '.js-infogfx-loading',
  },

  behaviors: {
    GenericVideoPlayer: {},
  },

  events: {
    'click @ui.xButton': 'close',
    'click @ui.saveButton': 'save',
    'click @ui.previewButton': 'preview',
  },

  initialize: function (options) {
    options = $.extend(
      {
        infogfxTemplate: null,
      },
      options
    );

    this.template = app.compileTemplate.$('#infogfx-modal-tmpl');
    this.story = options.model;

    const infogfxTemplateObj = _.find(this.INFOGFX_TEMPLATES, function (val) {
      return val.ID === options.infogfxTemplate;
    });

    if (!infogfxTemplateObj) {
      console.error(
        'Add infographics modal: initiated with invalid template type!'
      );
      this.close();
    }

    this.infogfxTemplateModel = new Backbone.Model(infogfxTemplateObj);
    this.miniVideoUrl = this.infogfxTemplateModel.get('DEMO');

    this.analyticsData = {
      eventPrefix: 'analytics:infogfxModal:',
      'Template Name': this.infogfxTemplateModel.get('CAPTION'),
    };
    this.track('select');

    this._resetPreviewObj();
  },

  onShow: function () {
    this.innerView = new app.namespace.View[
      this.infogfxTemplateModel.get('VIEW')
    ]({
      el: this.ui.innerView,
      model: this.infogfxTemplateModel,
      story: this.model,
    });
    this.innerView.on(
      'generate:static:preview',
      function () {
        this.preview(null, true);
      }.bind(this)
    );
    this.innerView.render().onShow();

    this.$el.attr('tabIndex', -1).trigger('focus'); // focus element to prevent bg scroll on keydown
    app.keyboardAccessibility.add(app.KEYBOARD_LAYER.CID, [
      {
        on: 'keydown',
        key: $.ui.keyCode.ESCAPE,
        inEditor: true,
        run: this.close.bind(this),
      },
    ]);
  },

  onBeforeDestroy: function () {
    this.freeCurrentPreview({ cancelFetch: false });
    app.keyboardAccessibility.remove(app.KEYBOARD_LAYER.CID);
    this.innerView.destroy();
    $(window).off('keydown' + this.eventNamespace);
  },

  track: function (e, obj) {
    let prefix;
    let params = {};
    prefix = this.analyticsData.eventPrefix;
    prefix = prefix || 'unknown';
    params = _.extend({}, this.analyticsData, obj);
    delete params.eventPrefix;
    Analytics.trigger(prefix + e + '', params);
  },

  close: function () {
    const isDirty = this.innerView.isDirty();

    if (isDirty) {
      app.dialog
        .confirm(
          {
            type: app.dialog.types.CONFIRM_2,
            title: 'Are you sure you want to exit?',
            buttonNoText: 'No',
          },
          {
            appendIdentifier: `#${this.id}`,
          }
        )
        .then((res) => {
          if (res.action) {
            this.freeCurrentPreview({ cancelFetch: true });
            this._closeDo();
          }
        });
    } else {
      this._closeDo();
    }
  },

  _closeDo: function () {
    app.controller.hideModal();
    this.track('close');
  },

  _resetPreviewObj: function (checksum) {
    this.previewObj = {
      status: null,
      checkSum: checksum,
      previewResultData: {},
      previewCdnUrl: null,
    };
  },

  generateInfogfxAsset: function (infogfxData, preview) {
    const promise = $.Deferred();
    const tmpChecksum = app.getHashCode(infogfxData);

    this.currentAssetModel = new app.namespace.Model.AssetModel(
      {
        type: infogfxData.assetType,
        unifiedBucketDisplayOrder: 0,
        bucketDirectory: 'MY_GALLERY',
        bucketType: 'INFOGRAPHICS_STOCK',
        metadata: {
          providerAssetId: $.now(),
          creationDate: $.now(),
          uploadStatus: app.uploadStatus.PROCESSING,
          caption: infogfxData.taskModel.caption,
          title: infogfxData.taskModel.title,
        },
      },
      {
        parse: true,
      }
    );

    // no need for realtime preview if preview is an image
    this.assetReq = $.ajax({
      url: app.apiUrl('/api/v1/assets/' + infogfxData.path),
      contentType: 'application/json',
      type: 'POST',
      data: JSON.stringify(
        $.extend(infogfxData.taskModel.data, {
          save: !preview,
        })
      ),
      success: function (response) {
        if (
          !_.isEmpty(response) &&
          response.assetResultsCount > 0 &&
          !_.isEmpty(response.assets)
        ) {
          const asset = response.assets[0];
          if (
            this.previewObj.checkSum == tmpChecksum &&
            _.size(this.previewObj.previewResultData)
          ) {
            asset.previewResultData = this.previewObj.previewResultData;
          }
          this.currentAssetModel.set(
            this.currentAssetModel.parse(asset, {
              bucketDirectory: 'MY_GALLERY',
            })
          );
          promise.resolve(this.currentAssetModel);
        } else {
          promise.reject();
          this._generateInfogfxAssetFailed(preview);
        }
      }.bind(this),
      error: function (error) {
        promise.reject(error);
        this._generateInfogfxAssetFailed(preview);
      }.bind(this),
    });
    return promise;
  },

  _generateInfogfxAssetFailed: function (preview) {
    if (!preview) {
      this.currentAssetModel.setMetadata(
        'uploadStatus',
        app.uploadStatus.FAILED
      );
      this.track('save:error');
      this.ui.loading.removeClass('show-loading');
      this.trigger('miniVideo:error:show', 'Save Failed');
    } else {
      this.track('preview:error');
    }
  },

  freeCurrentPreview: function (options) {
    options = $.extend(
      {
        cancelFetch: false,
        fromCreate: false,
      },
      options
    );
    this.assetReq &&
      options.cancelFetch &&
      this.assetReq.abort(options.fromCreate ? 'skip' : 'abort');
    if (this.previewObj.status === 'PROCESSING') {
      this.previewObj.status = 'FAIL';
      if (typeof this._getPreviewTimeout !== 'undefined') {
        clearTimeout(this._getPreviewTimeout);
      }
      app.api.renderAsset.ABORT({
        url: this.previewObj.previewCdnUrl,
        checksum: this.previewObj.checkSum,
        uuid: this.currentAssetModel.getMetadata('assetUUID'),
        previewId: this.previewObj.previewId,
      });
      if (this.previewObj.previewId) {
        app.api.realTime.cancelListenRealtimePreview({
          assetUUID: this.previewObj.assetId,
          previewId: this.previewObj.previewId,
        });
      }
    }
  },

  preview: function (e, isStatic) {
    if (_.isUndefined(isStatic)) {
      isStatic = false;
    }
    const infogfxData = this.innerView.serialize();
    const tmpPreviewHash = app.getHashCode(infogfxData);

    if (tmpPreviewHash == this.previewObj.checkSum && !this.previewObj.fail) {
      return; // prevent duplicated preview work
    }

    this._resetPreviewObj(tmpPreviewHash);

    this.freeCurrentPreview({
      cancelFetch: true,
    });

    this.track('preview', {
      Validation: infogfxData ? true : false,
    });

    if (!infogfxData) {
      return false;
    } else {
      this.trigger('miniVideo:preview:start');
      this.generateInfogfxAsset(infogfxData, true)
        .done((infogfxModel) => {
          if (this.infogfxTemplateModel.get('PREVIEW_TYPE') === 'VIDEO') {
            // no need to generate real time preview if the preview's an image
            $.extend(this.previewObj, {
              status: 'PROCESSING',
              checkSum: this.previewObj.checkSum,
            });

            const programmer = this.story.getProgrammer();
            const storyId = this.story.get && this.story.get('id');
            app.api.renderAsset
              .POST({
                assetModel: $.extend(infogfxModel.serialize(), {
                  displayDuration: programmer.get('configInitialInfoGfxDT'),
                  displayEndTime: programmer.get('configInitialInfoGfxDT'),
                  displayStartTime: 0,
                }),
                checksum: this.previewObj.checkSum,
                topicId: app.currentTopicId,
                programmerId: programmer.id,
                aspectRatio: app.DEFAULT.ASPECT_RATIO,
                themeId: app.rootStore.state.story.themeInfo.themeId,
                RealtimePreviewType: isStatic
                  ? app.RealtimePreviewType.STATIC
                  : app.RealtimePreviewType.VIDEO,
                storyId,
              })
              .done((response) => {
                app.prependHttpAcrossObject(response);

                $.extend(this.previewObj, {
                  assetId: infogfxModel.getMetadata('assetUUID'),
                  previewId: response.previewResultData.previewId,
                  previewCdnUrl: response.previewResultData.cdnUrl,
                });

                app.api.realTime
                  .listenRealtimePreview({
                    assetUUID: this.previewObj.assetId,
                    previewId: this.previewObj.previewId,
                  })
                  .done(() => {
                    app.api.realTime.cancelListenRealtimePreview({
                      assetUUID: this.previewObj.assetId,
                      previewId: this.previewObj.previewId,
                    });
                    this._pollPreview();
                  })
                  .progress(() => {
                    this._pollPreview();
                  })
                  .fail(this._previewFailed.bind(this));
              })
              .fail(this._previewFailed.bind(this));
          } else {
            // lets just set the image as the preview url
            this.trigger(
              'miniVideo:url:set',
              infogfxModel.getMetadata('urlCdn')
            );
          }
        })
        .fail(this._previewFailed.bind(this));
    }
  },
  generateStaticPreview: function () {},
  _pollPreview: function () {
    app.api.renderAsset
      .GET({
        programmerId: this.story.getProgrammer().id,
        url: this.previewObj.previewCdnUrl,
        checksum: this.previewObj.checkSum,
        uuid: this.currentAssetModel.getMetadata('assetUUID'),
        previewId: this.previewObj.previewId,
      })
      .done(
        function (response) {
          app.prependHttpAcrossObject(response);
          $.extend(this.previewObj, {
            status: 'DONE',
            previewResultData: response.previewResultData,
          });
          this.trigger(
            'miniVideo:url:set',
            this.previewObj.previewResultData.cdnUrl
          );
        }.bind(this)
      )
      .fail(
        function () {
          this._getPreviewTimeout = setTimeout(
            function () {
              this._pollPreview();
            }.bind(this),
            1000
          );
        }.bind(this)
      );
  },

  _previewFailed: function (err) {
    const errMsg = err && err.statusText;
    if (errMsg === 'skip') {
      return;
    }
    this.previewObj.status = 'FAIL';
    this.trigger('miniVideo:preview:end');
    this.trigger('miniVideo:error:show', 'Preview Failed');
  },

  save: function () {
    this.trigger('miniVideo:preview:end');
    this.ui.loading.addClass('show-loading');
    const createProm = this.create();
    createProm.then(() => {
      // renders uploading asset
      this.trigger(
        'infogfxGallery:newAsset',
        _.cloneDeep(this.currentAssetModel.attributes)
      );
      this.ui.loading.removeClass('show-loading');
      app.controller.hideModal();
    });

    createProm.catch(() => {
      this.ui.loading.removeClass('show-loading');
    });
  },

  create: function () {
    const infogfxData = this.innerView.serialize();
    const promise = new _.ColdPromise();
    this.freeCurrentPreview({
      cancelFetch: true,
      fromCreate: true,
    });
    this.track('save', {
      Validation: !!infogfxData,
    });

    if (!infogfxData) {
      promise.reject();
    } else {
      this.generateInfogfxAsset(infogfxData, false).then(
        promise.resolve,
        promise.reject
      );
    }

    return promise;
  },
});

export default app.namespace.View.InfogfxModalView;
